export const marcinOrlowski = {
    'meta': {
        'title': 'Psychoterapeuta Marcin Orłowski • Centrum COLLIGO',
        'description': 'Jestem psychologiem oraz psychoterapeutą pracującym w nurcie psychodynamicznym. Od 2013 roku pracuję w Toruniu, na całodobowym Oddziale Psychiatrycznym.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-marcin-orlowski/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/marcin-orlowski.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Marcin Orłowski • Centrum COLLIGO w Toruniu'
        }
    }
}